import PlanoContas from "../PlanoContas";
import ContasBancarias from "../ContasBancarias";
import InstrucoesBoleto from "../InstrucoesBoleto";
import DadosCadastrais from "../DadosCadastrais";
import GruposDeDesconto from "../GruposDeDesconto";
import ParametrosCobrancaForm from "components/Features/Parametros/ModalParametrosCobranca/ParametrosCobrancaForm";
import MetodosCobranca from "../MetodosCobranca";
import { TabsMenuOptionsRoutes } from "core/features/tenants/data/TabsMenuOptions";
import { TenantDetalhe } from "features/tenants/typings/tenant";
import TenantUsuarios from "../Usuarios";
import Unidades from "components/Features/Unidades/ListUnidades";
import Feriados from "../Feriados";
import ConfiguracaoWhiteLabel from "../ConfiguracaoWhiteLabel/index";
import CentrosDeCusto from '../CentrosDeCusto/index';

function TenantTabs({
  id,
  tenantId,
  tabActive,
  tenant,
  onSubmitSuccess,
}: {
  id?: string;
  tenantId?: string;
  tabActive: TabsMenuOptionsRoutes;
  tenant?: TenantDetalhe;
  onSubmitSuccess: (id: string) => void;
}) {
  const enableEditOptions = !!id || !!tenantId;
  const _tenantId = id || tenantId;

  if (tabActive === TabsMenuOptionsRoutes.ContaBancarias) {
    return <ContasBancarias tenant={_tenantId} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.CentrosDeCusto) {
    return <CentrosDeCusto tenant={_tenantId} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.PlanoDeContas) {
    return <PlanoContas tenant={_tenantId} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.Parametrizacoes) {
    return <ParametrosCobrancaForm tenant={_tenantId} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.GruposDeDesconto) {
    return <GruposDeDesconto tenantId={_tenantId!} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.Feriados) {
    return <Feriados tenantId={_tenantId!} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.InstrucaoBoleto) {
    return <InstrucoesBoleto tenantId={_tenantId!} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.MetodosCobranca) {
    return <MetodosCobranca tenant={{ ...tenant!, id: _tenantId! }} />;
  }

  if (tabActive === TabsMenuOptionsRoutes.WhiteLabel) {
    return <ConfiguracaoWhiteLabel tenantId={_tenantId!} />;
  }

  return (
    <>
      {tabActive === TabsMenuOptionsRoutes.Dados ? (
        <DadosCadastrais
          tenantId={_tenantId}
          onSubmitSuccess={(result) => onSubmitSuccess(result)}
          isEdit={enableEditOptions}
          defaultData={tenant}
          tipoTenantId={tenant?.tipoTenantId!}
        />
      ) : null}

      {tabActive === TabsMenuOptionsRoutes.UsuariosLegais && _tenantId ? (
        <TenantUsuarios
          tipoTenantId={tenant?.tipoTenantId!}
          tenantId={_tenantId}
        />
      ) : null}

      {tabActive === TabsMenuOptionsRoutes.Unidades ? (
        <Unidades isCondominio tenantId={_tenantId!} />
      ) : null}
    </>
  );
}

export default TenantTabs;
